/**获取出入库源单据详情*/
export const API_GET_BILL_DETAIL = {
  url: 'statementSourceBill/inOutDetail',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**获取协议结算业务明细列表*/
export const API_GET_BUSINESSDETAIL = {
  url: 'agreementSettleBusinessDetail',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取结算单列表*/
export const API_GET_SETTLEBILLLIST = {
  url: 'settleBill',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取协议结算业务明细列表-目标返利*/
export const API_GET_BUSINESSDETAIL_BYSETTLENO = {
  url: 'agreementSettleBusinessDetail/getDetailBySettleNo',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**获取明细列表-促销扣款*/
export const API_GET_BILLCOSTDETAIL = {
  url: 'getDetailBySettleNo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

// /**获取单据类型*/
// export const API_GET_BILLTYPE = {
//   url: 'statementSourceBill/getbilltype',
//   config: {
//     method: 'get',
//     host: 'CAISX_SETTLE'
//   }
// };

// /**获取发生地点*/
// export const API_GET_HAPPENPLACE = {
//   url: 'statementSourceBill/getHappenPlace',
//   config: {
//     method: 'get',
//     host: 'CAISX_SETTLE'
//   }
// };

/** 是否为无纸settle/signData/isSignSupplier*/
export const API_GET_SETTLE_SIGNDATA_ISSIGNSUPPLIER = {
  url: 'signData/isSignSupplier',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**新建/编辑供应商子账号*/
export const API_POST_SYSTEM_SETTING_SUBSUPPLIER_CREATEOREDIT = {
  url: 'system/settings/subSupplier/createOrEdit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**子账号列表*/
export const API_GET_SYSTEM_SETTING_DEFAULT_SUPPLIER = {
  url: 'system/settings/subSupplier/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 子账号导出*/
export const API_GET_SYSTEM_SETTING_SUBSUPPLIER_LIST_EXPORT = {
  url: 'system/settings/subSupplier/list/export',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**重置供应商子账号密码*/
export const API_POST_SYSTEM_SETTING_SUBSUPPLIER_RESET = {
  url: 'system/settings/subSupplier/reset',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 禁用/启用供应商子账号*/
export const API_POST_SYSTEM_SETTING_SUBSUPPLIER_STATUS = {
  url: 'system/settings/subSupplier/status',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**用户中心角色列表*/
export const API_GET_PUBLIC_USER_ROLES = {
  url: 'public/user/roles',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**校验供应商信息*/
export const API_POST_REGISTER_CHECK_SUPPLIER = {
  url: 'register/check/supplier',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**获取手机验证码*/
export const API_GET_REGISTER_GET_VERIFYCODE = {
  url: 'register/get/verifyCode',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**填写个人信息并提交注册*/
export const API_POST_REGISTER_SUBMIT = {
  url: 'register/submit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**票核情况查询-总计*/
export const API_GET_GETINVOICELISTSTATISTICS = {
  url: 'invoice/getInvoiceListStatistics',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**发票录入-导出*/
export const API_GET_INVOICE_CHECKTICKET_EXPORT = {
  url: 'invoice/exportCheckTicketList',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**电子签章-获取税号手机号码*/
export const API_GET_GETTAXCODEMOBILE = {
  url: 'signMobile/getTaxCodeMobile',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**根据模块获取签章授权供应商编号*/
export const API_GET_SIGNMOBILE_ALLSUPPLIER = {
  url: 'signMobile/allSupplier/$supplierCode/$module',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 校验是否有对账配置
export const API_GET_CHECKSETTINGS = {
  url: 'statementSupplierLimit/checkStatement',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 校验是否开启票核的灰度逻辑
export const API_GET_PIAOHE_GRAY_SWITCH = {
  url: 'invoice/getCloseFlag',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
